<template>
    <AppLayout>
        <div class="home" style="margin-top: 110px !important;">
            <section id="settings-categories">
                <div class="container ">
              <h5 class="mb-3 fw-bold">Document Types</h5>
              <div class="panel">
                <label for="">1. Document Types</label>
                <div class="row mt-2">
                    <div class="col-md-2">
                        <input type="text"  class="form-control" placeholder="Enter document type" v-model="name" >
                    </div>
                    <div class="col-md-2 d-flex align-items-center mt-2">
                        <input type="checkbox" id="isMandatory" v-model="isMandatory" class="me-2" style="width: 18px; height: 18px;" >
                        <label for="isMandatory" class="mb-0 ms-2">Mandatory</label>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-primary btn-small mt-2" @click="postDocumentType">Add</button>
                    </div>
                    <div class="col-md-2" v-if="documentDisplay =='none'">
                        <button v-if="!isBusinessDevelopmentMode" class="btn-small btn btn-default" style="border: 1px solid #f2f2f2; float: right;" @click="documentDisplay='block', this.fetchDocumentTypes()">View List</button>
                    </div>
                </div>
            
                <div class="row mt-4" :style="{ 'display': documentDisplay }">
                    <h6>Documents list <button class="btn btn-sm btn-default pull-right text-primary" @click="documentDisplay='none'" style="float:right;">Hide List</button></h6>
                    <table class="table table-hover">
                        <thead>
                            <th>No.</th>
                            <th>Document Type </th>
                            <th>Mandatory</th>
                            <th>Action</th>
                        </thead>
                        <tbody>
                            <tr v-for="(doc,index) in documentTypes" v-bind:key="doc.id">
                                <td>{{ index+1 }}</td>
                                <td>{{ doc.name}}</td>
                                <td>
                                    <input type="checkbox" v-model="doc.isMandatory" @change="updateDocumentType(doc)" style="width: 18px; height: 18px;" >
                                </td>
                                <td><button class="btn-sm btn btn-danger" @click="deleteDocumentType(doc.id)">Delete</button></td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div>
                
            </div>
            </div>
        </section> 
    </div>
</AppLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
//import axios from 'axios'

export default {
  name: 'SettingsDocumentTypesPage',
  data: () => ({
    token: JSON.parse(localStorage.getItem('access_token')),
    urlServer:process.env.VUE_APP_URL,
    name: "",
    isMandatory: false,
    documentDisplay: "none",
  }),

  
  computed:{
        ... mapGetters (["getDocumentTypes"]),
        documentTypes () { return this.getDocumentTypes },
        isBusinessDevelopmentMode() {
            const path = this.$route?.path || '';
            const active = localStorage.getItem('active_module') || '';
            return active === 'business-development' || path.startsWith('/admin/bid');
        },
  },

  methods:{
    ... mapActions(['fetchDocumentTypes']),
    async postDocumentType() {
      const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          body: JSON.stringify({ 
              name: this.name,
              isMandatory: this.isMandatory
          })
      };
      const res = await fetch(process.env.VUE_APP_URL+'/documents', requestOptions)
      const data = await res.json()
      if(data.status == true){
          this.documentDisplay = 'block';
          this.name = "";
          this.isMandatory = false;
          this.fetchDocumentTypes();
      }else{
          Swal.fire({
              icon: 'error',
              title: 'Document Type not added',
              text: data.message
          })
      }
    },

    async deleteDocumentType (id) {
      const requestOptions = {
          method: "DELETE",
          headers: { 
            'Accept': 'application/json',
            'Authorization': 'Bearer '+this.token 
          },
      };
      const res = await fetch(process.env.VUE_APP_URL+'/documents/'+id, requestOptions)
      const data = await res.json()
      if(data.status == true){
          Swal.fire({
              icon: 'success',
              title: 'Document Type deleted successfully',
              text: 'Document Type  deleted'
          })
          this.fetchDocumentTypes();
      }else{
          Swal.fire({
              icon: 'error',
              title: 'Document Type not deleted',
              text: data.message
          })
      }
    },

    async updateDocumentType (doc) {
      const requestOptions = {
          method: "PATCH",
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+this.token 
          },
          body: JSON.stringify({ 
              name: doc.name,
              isMandatory: doc.isMandatory
          })
      };
      const res = await fetch(process.env.VUE_APP_URL+'/documents/'+doc.id, requestOptions)
      const data = await res.json()
      if(data.status == true){
          Swal.fire({
              icon: 'success',
              title: 'Updated',
              text: 'Document Type updated',
              timer: 1500,
              showConfirmButton: false
          })
      }else{
          Swal.fire({
              icon: 'error',
              title: 'Not updated',
              text: data.message
          })
          // Revert on failure
          doc.isMandatory = !doc.isMandatory;
      }
    },
  }

}

</script>





